export const STORE_TIER = {
  FREE: "FREE",
  START: "START",
  ALFRED: "ALFRED",
} as const

export type StoreTier = (typeof STORE_TIER)[keyof typeof STORE_TIER]
